var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsKong = function SvgMillustrationsKong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "m27.622 16.203.572-1.058 1.716-1.387 2.942 2.306-.382.389.512.709v.758l-1.466 1.198-2.459-2.915zm-.256.393-1.195 2.064 5.837 6.775-.168.62h2.676l.484-2.21-6.241-7.25zm-1.617 7.252-.335.431.755 1.217-.076.56h3.191l.23-.56-1.29-1.648zm-1.895-3.034h-.778L21 23.386v2.67h2.224l.394-.502 1.712-2.177h2.48l.758-1.137-2.687-3.122z",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsKong;